// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2OqmZ","dragIcon":"Choice_dragIcon__1UyJd","left":"Choice_left__1keCG","input":"Choice_input__wLomk"};